var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceLadder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    display: "inline",
    strokeWidth: 0.262528,
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.268 48.617V60.18h-2.145V49.758h-.994V60.18h-2.137V51.242h-1V60.18h-2.849v1.008H22.545V60.18h-1.283V48.617Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(.001 -40)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.999998,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.195 42.813v1.005h1.848L16.01 46.9l-1.707-1.73-3.836 4.133-.211.226a5.662 5.662 0 0 0-3.082-.912c-3.156 0-5.72 2.584-5.72 5.758s2.564 5.76 5.72 5.76c3.156 0 5.726-2.586 5.726-5.76 0-1.67-.715-3.171-1.85-4.225l.151-.162 3.131-3.37 1.678 1.7 3.724-3.785v1.86h1v-3.58h-3.033Zm-10.021 6.81a4.735 4.735 0 0 1 4.732 4.752 4.737 4.737 0 0 1-4.732 4.754c-2.617 0-4.727-2.121-4.727-4.754 0-2.633 2.11-4.752 4.727-4.752z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(.001 -40)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.999998,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "fill markers stroke",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.674 51.252V52.049H5.422v2.826H7.93v.822H5.422v1.006h1.252V57.5h1.004v-.796h1.246v-2.835h-2.5v-.814h2.5v-1.006H7.678V51.252z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(.001 -40)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.999998,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceLadder);
export default __webpack_public_path__ + "static/media/price_ladder.d2a91e57f8f582ba4726b1a0e3a308d7.svg";
export { ForwardRef as ReactComponent };